import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useCreateClientMutation } from '@/modules/common/queries/clients.ts';
import {
  ClientFormValues,
  ClientModal,
} from '@/modules/admin-dashboard/components/modals/ClientModal.tsx';
import { BaseModalProps } from 'ui';

const initialValues: ClientFormValues = {
  name: '',
  phone_number: '',
  email: '',
};

const clientValidationSchema = Yup.object().shape({
  name: Yup.string().required('Client name is required'),
  email: Yup.string().email('Invalid email address'),
  phone_number: Yup.string(),
});

export const CreateClientModal = ({ open, onClose }: BaseModalProps) => {
  const { mutateAsync: createClient, isLoading } = useCreateClientMutation();

  const formik = useFormik<ClientFormValues>({
    initialValues,
    validationSchema: clientValidationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { resetForm }) => {
      await createClient({
        name: values.name.trim(),
        phone_number: values.phone_number.trim() || undefined,
        email: values.email.trim() || undefined,
      });
      resetForm();
      onClose();
    },
  });

  return (
    <ClientModal
      open={open}
      onClose={() => {
        formik.resetForm();
        onClose();
      }}
      formik={formik}
      isSubmitting={isLoading}
    />
  );
};

export default CreateClientModal;
